<div class="rd-widget" style="background-color: white;" *ngIf="(widgetData$ | async) as widgetData">

  <table aria-hidden="true" class="chart-widget-table-container" [style.min-height]="tableContainerHeight">
    <tr>
      <td>
        <div class="layout-buttons-wrapper">
          <button kendoButton (click)="toggle()" class="widgetButton toggleButton">
            <svg-icon class="navigation-icon" src='./assets/icons/switch.svg' align='center'></svg-icon>
          </button>
          <div class="dashboardHandle"></div>
          <div class="widget-title">
            {{'widgets.leaseExpiry.leaseExpiry' | translate | uppercase}} &nbsp;
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="chart-table-wrapper">

        <div *ngIf="!displayTableData" class="k-donut-chart-container-print-fix">
          <div class="k-donut-chart-wrapper">
            <kendo-chart class="k-donut-chart-area" (render)="onRender($event)">
              <kendo-chart-area background="none"></kendo-chart-area>

              <ng-template kendoChartDonutCenterTemplate>
                <h3 [style.fontSize]="(textScale*32) + 'px'">{{currency}}{{ widgetData.displayValue | number:"1.0-0"}}</h3>
                <p [style.fontSize]="(textScale*20) + 'px'">{{'widgets.leaseExpiry.leaseExpiry' | translate }}</p>
              </ng-template>

              <kendo-chart-series>
                <kendo-chart-series-item type="donut" [data]="widgetData.entries" categoryField="label" field="value" [color]="getColor" [size]="(donutHoleScale*30)" [holeSize]="(donutHoleScale*120)" [autoFit]="true">
                  <kendo-chart-series-item-labels position="outsideEnd"
                                                  color="#000"
                                                  [content]="labelContent">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
            </kendo-chart>
          </div>
        </div>

        <table *ngIf="displayTableData" class="widget-large widgetNoTopBorder widget-table-data" aria-hidden="true">
          <tbody>
            <tr>
              <td colspan="6" class="widget-column-header">{{'widgets.leaseExpiry.periodToExp' | translate }}</td>
              <td colspan="6" class="widget-column-header">{{'widgets.leaseExpiry.contractedRent' | translate }} | {{currency}}</td>
              <td colspan="6" class="widget-column-header">{{'widgets.leaseExpiry.contractedRentPerc' | translate }}</td>
            </tr>
            <tr *ngFor="let entry of widgetData.entries" class="content-row">
              <td colspan="6" class="widget-column-value" *ngIf="entry.label !== '<1'"> {{ entry.label}} years </td>
              <td colspan="6" class="widget-column-value" *ngIf="entry.label === '<1'"> {{ entry.label}} year </td>
              <td colspan="6" class="widget-column-value">  {{ entry.displayValue | number:"1.0-0"}} </td>
              <td colspan="6" class="widget-column-value "> {{ entry.value | number: '1.2-2'}}% </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;"> {{'widgets.leaseExpiry.total' | translate }}</td>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;"> {{ widgetData.displayValue | number:"1.0-0"}} </td>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;"> {{ widgetData.value}}%</td>
            </tr>
            <tr>
              <td colspan="16">&nbsp;</td>
            </tr>
          </tfoot>
        </table>

      </td>
    </tr>
  </table>

</div>
